const minDateNow = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
  return today
}

export default () => ({
  errors: {},
  show: false,
  isCovids: true,
  isShow: true,
  loading: false,
  onCancel: true,
  fullPage: true,
  isMobiled: false,
  isShowing: false,
  showModal: false,
  isDisabled: false,
  isPassword: false,
  isSheduled: false,
  showModalAccountDisabled: false,
  showModalPassword: false,
  commonAreaOptions: [],
  commonAreaSelected: [],
  guest_list_id: null,
  persons: [],
  area_id: null,
  availableDay: [],
  charge_for_hours: false,
  scheduleByDay: false,
  sexOptions: [
    {id: 'male', label: 'Masculino'},
    {id: 'female', label: 'Feminino'}
  ],
  schedule: {
    id: null,
    event_name: null,
    title: null,
    start_date: null,
    end_date: null,
    tower_id: null,
    unit_id: null,
    dweller_guest_list_id: null,
    go_in: null,
    go_out: null
  },
  scheduleTimes: [],
  scheduleSelected: [],
  guest: {
    name: null
  },
  person: {
    name: null,
    dweller_guest_list_id: null
  },
  profile: {
    'name': null,
    'contact_name_first': null,
    'contact_phone_first': null,
    'contact_name_second': null,
    'contact_phone_second': null,
    'country_register': null,
    'phone': null
  },
  dtSave: {
    sideBySide: true,
    useCurrent: false,
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    },
    inline: true
  },
  listGuest: [],
  dates: [],
  minDate: minDateNow(),
  dwellerTowers: [],
  dwellerUnits: [],
  dwellerGuestListOptions: [],
  options: [],
  id_common_area: null,
  timeOptions: [
    {id: '00:59', label: '01:00'},
    {id: '01:59', label: '02:00'},
    {id: '02:59', label: '03:00'},
    {id: '03:59', label: '04:00'},
    {id: '04:59', label: '05:00'},
    {id: '05:59', label: '06:00'},
    {id: '06:59', label: '07:00'},
    {id: '07:59', label: '08:00'},
    {id: '08:59', label: '09:00'},
    {id: '09:59', label: '10:00'},
    {id: '10:59', label: '11:00'},
    {id: '11:59', label: '12:00'},
    {id: '12:59', label: '13:00'},
    {id: '13:59', label: '14:00'},
    {id: '14:59', label: '15:00'},
    {id: '15:59', label: '16:00'},
    {id: '16:59', label: '17:00'},
    {id: '17:59', label: '18:00'},
    {id: '18:59', label: '19:00'},
    {id: '19:59', label: '20:00'},
    {id: '20:59', label: '21:00'},
    {id: '21:59', label: '22:00'},
    {id: '22:59', label: '23:00'},
    {id: '23:59', label: '00:00'}
  ],
  timeOptionsQuadra: [
    {id: '09:59', label: '10:00'},
    {id: '10:59', label: '11:00'},
    {id: '11:59', label: '12:00'},
    {id: '12:59', label: '13:00'},
    {id: '13:59', label: '14:00'},
    {id: '14:59', label: '15:00'},
    {id: '15:59', label: '16:00'},
    {id: '16:59', label: '17:00'},
    {id: '17:59', label: '18:00'},
    {id: '18:59', label: '19:00'},
    {id: '19:59', label: '20:00'},
    {id: '20:59', label: '21:00'},
    {id: '21:59', label: '22:00'}
  ],
  back: false,
  currentIndex: 0,
  locale: {
    lang: {
      name: 'it',
      weekdays: 'Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sabado'.split('_'),
      weekdaysShort: 'dom_seg_ter_qua_qui_sex_sab'.split('_'),
      weekStart: 1,
      months: 'Janeiro_Fervereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
      monthsShort: 'Jan_Fer_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
      formats: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
      },
      ordinal: n => `${n}º`,
      buttonCancel: 'Cancela',
      buttonValidate: 'Ok',
      rangeHeaderText: 'De %d até'
    }
  },
  weekdays: [
    'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'
  ],
  months: [
    'Janeiro', 'Fervereiro', 'Março', 'Abril',
    'Maio', 'Junho', 'Julho', 'Agosto',
    'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ],
  isScheduled: false
})



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/resources/data.js